import React, { Component } from 'react';
import styled from 'styled-components';
import { PrestoAppComponents, PrestoAppTheme, PrestoAppUtils } from 'presto-mini-apps-lib';
import {
    term_details,
    term_paymentAmount,
    term_item
} from '../../constants/text';


class PaymentDetails extends Component {
    render() {
        const {
            payAmount,
            paymentDetails,
            itemList,
            appState,
        } = this.props;

        return ((!!payAmount && +payAmount > 0) ? (
            <PaymentDetailsWrapper className="payment-details-component">
                <div className="pay-amount">
                    <div className="label">{term_paymentAmount}</div>
                    <div className="amount">
                        {appState.curCode.currency + PrestoAppUtils.convertToCurrency(payAmount / 100)}
                    </div>
                </div>
                <div className="payment-details">
                    <div className="label">{term_details}</div>
                    <div className="description">{paymentDetails}</div>
                </div>
                <PrestoAppComponents.HorizontalLine
                    gap={PrestoAppTheme.layout.smallGap}/>
                { (!!itemList && itemList.length > 0) && (
                    <React.Fragment>
                        <div className="cart-title">{term_item}</div>
                        <ul className="cart-items">
                            { itemList.map((item, key) => (
                                <li key={key} className="item-row">
                                    <div className="item-title">{item.itemDesc}</div>
                                    <div className="item-quantity">{item.quantity}</div>
                                </li>
                            ))}
                        </ul>
                        <PrestoAppComponents.HorizontalLine
                            gap={PrestoAppTheme.layout.smallGap}/>
                    </React.Fragment>
                )}
            </PaymentDetailsWrapper>
        ) : null);
    }
}

export default PaymentDetails;


const PaymentDetailsWrapper = styled.div`
    padding: ${PrestoAppTheme.layout.smallGap} ${PrestoAppTheme.layout.smallGap} 0;
    box-sizing: border-box;
    
    & .pay-amount {
        text-align: center;
        margin-bottom: ${PrestoAppTheme.layout.largeGap}; 
        
        & > .amount {
            font-size: 1.75rem;
            font-weight: 500;
        }
        
        & > .label {
            margin-top: ${PrestoAppTheme.layout.xSmallGap};
            color: ${PrestoAppTheme.colors.baseGrey};
            text-transform: uppercase;
            font-weight: 400;
        }
    }
    
    & .payment-details {
        display: flex;
        justify-content: space-between;
        
        & > .label { 
            margin-right: ${PrestoAppTheme.layout.smallGap};
            color: ${PrestoAppTheme.colors.baseGreyDark};
        }
        & > .description { 
            font-weight: 400;
        }
    }

    & .cart-title {
        color: ${PrestoAppTheme.colors.baseGreyDark};
        margin-bottom: ${PrestoAppTheme.layout.smallGap};
    }
    
    & .cart-items {
        ${PrestoAppTheme.layout.blankListStyle}; 
        
        & > li {
            display: flex;
            margin: ${PrestoAppTheme.layout.xSmallGap} 0;
            justify-content: space-between;
            font-weight: 400;

            & .item-title { 

            }

            & .item-quantity { 
                min-width: 2.1875rem; // 35px
                text-align: right;

                &:before {
                    content: 'x';
                }
            }
        }
    }
`;
